<template>
  <!-- 添加绑定关系 -->
     <el-dialog
     :append-to-body="true"
     :visible.sync="showAddView.show"
      :close-on-click-modal="false"
     class="dialogView"
      width="25%">
      <span slot="title" class="title">
        <span>添加绑定关系</span>
      </span>
      <el-row>
        <span class="star">*</span>上传绑定文件
        <el-tooltip content="上传绑定文件" placement="right" effect="light">
          <span class="el-icon-question"></span>
        </el-tooltip>
      </el-row>
      <el-row>
        <el-upload
          class="upload"
          action="aa"
          :auto-upload="false"
           :on-change="handleChange"
           :on-remove="handleRemove"
          :limit="1"
          :submit="addBind"
          :http-request="getFile"
          :file-list="fileList">
          <el-button size="small" type="">点击上传</el-button>
          <span  class="link" @click="getCsvTemplate">下载csv模板</span>
        </el-upload>
      </el-row>
      <span slot="footer" class="dialog-footer">
        <el-button  type="primary" size="small" @click="addBind">保 存</el-button>
        <el-button  size="small" @click="closeView">取 消</el-button>
      </span>
    </el-dialog>
</template>
<script>
import { csvTemplate, bindCert } from '@/api/productControl'
import { loadFileByUrl } from '@/utils'
export default {
  props: {
    showAddView: {
      type: Object
    },
    registerCertId: {
      type: String
    }
  },
  methods: {
    closeView () {
      this.$emit('close-view')
    },
    getCsvTemplate () {
      csvTemplate().then(res => {
        res = res.data
        console.log('返回的下载数据：', res)
        if (res.data) {
          // window.open(res.data)
          loadFileByUrl(res.data)
        } else {
          this.$message.error('下载出错')
        }
      })
    },
    // 获取选择的文件
    getFile (item) {
      console.log('获取到的文件：', item.file)
      this.file = item.file
    },
    // 保存发起
    addBind () {
      console.log('fileList:', this.fileList)
      // const file = this.fileList[0]
      const formData = new FormData()
      formData.append('multiPartFile', document.getElementsByClassName('el-upload__input')[0].files[0])
      // formData.append('registerCertId', 'e867e537b96d405d98b8bd8e36e42b7a')
      console.log('this.registerCertId:', this.registerCertId)
      formData.append('registerCertId', this.registerCertId)
      this.fileList.length > 0
        ? (
          bindCert(formData).then(res => {
            res = res.data
            console.log('绑定证书返回的数据：', res)
            if (res.code === 200) {
              this.$message({
                message: '恭喜你，添加绑定成功',
                type: 'success'
              })
              // 关闭弹窗
              this.$emit('close-view')
            } else {
              this.$message.error(res.message)
            }
          })
        )
        : this.$message('请先选择绑定文件')
    },
    handleChange (file, fileList) {
      this.fileList = fileList
      console.log('handleChange fileList:', fileList)
    },
    handleRemove (file, fileList) {
      this.fileList = fileList
      console.log('handleRemove:', file, fileList)
    }
  },
  data () {
    return {
      fileList: [
      ]
    }
  },
  mounted () {
    console.log('====================================')
    console.log('showAddView:', this.showAddView)
    console.log('====================================')
  }
}
</script>
<style lang="less" scope>
.dialogView{
    .title{
      font-size: 20px;
    }
    .el-icon-question{
      margin-left: 5px;
      color: rgb(204, 204, 204);
    }
    .tips{
      padding: 15px;
      background: #fbfbfc;
      border: 1px solid #ecedee;
      font-size: 10px;
      white-space: nowrap;
      line-height: 25px;
      .tipContent{
         display: flex;
      }
      .link{
        color: #35a6df;
        cursor: pointer;
      }
    }
    .el-row{
      margin-top: 5px;
    }
    .star{
      color: red;
      margin-right: 5px;
    }
    .upload{
      display: inline-block;
    }
  }
</style>
